define("ember-composable-helpers/helpers/pick", ["exports", "@ember/component/helper", "@ember/object"], function (_exports, _helper, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.pick = pick;
  function pick(_ref /*, hash*/) {
    let [path, action] = _ref;
    return function (event) {
      let value = (0, _object.get)(event, path);
      if (!action) {
        return value;
      }
      action(value);
    };
  }
  var _default = _exports.default = (0, _helper.helper)(pick);
});